// extracted by mini-css-extract-plugin
export default {"modalFooter":"klTN3I7GJb_landings","onScroll":"_trYhNPzoG_landings","full-screen":"L9nrAHsYX5_landings","column":"ofDovuHpSE_landings"};